export const restoreAll = "ffT9qe";
export default {restoreAll};